


















import { Component, Vue } from 'vue-property-decorator'
import { Api } from '@/service/api'

@Component({
  components: {
  }
})
export default class Entry extends Vue {

  private data: any = null

  private mounted () {
    this.loadGzhMenu()
  }

  private async loadGzhMenu () {
    const res: any = await Api.loadGzhList()
    this.data = res.data.menu
  }

  private menuDetails (id: any) {
    this.$router.push({ path: '/gzh_menu_manager', query: { app_id: id } })
  }
}
